import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';

const ContextPage = React.createContext();

const PageContextProvider = ({ page = {}, content = {}, children }) => {
  const [stateContent, setContent] = useState(content);

  const memoValue = useMemo(() => ({
    page,
    content: stateContent,
    setContent
  }), [page, stateContent])

  return (
    <ContextPage.Provider value={memoValue}>
      {children}
    </ContextPage.Provider>
  );
};

PageContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
  content: PropTypes.shape(PropTypes.object.isNotNull),
  page: PropTypes.shape(PropTypes.object.isNotNull),
};


export { ContextPage, PageContextProvider };
